export default Object.freeze({
    ENGLISH: 'English',
    FRENCH: 'French',
    GERMAN: 'German',
    SPANISH: 'Spanish',
    RUSSIAN: 'Russian',
    OTHER: 'Other',
})
